import React from 'react';
import { Check, Sparkles, MessageSquare, ArrowRight } from 'lucide-react';
import { trackWhatsAppClick } from '../services/adminStorage';

export default function PricingSection({ onChoosePlan, onContact }) {
  const plans = [
    {
      id: 'mensal',
      name: 'Assinatura Mensal',
      price: 'R$ 85,00',
      period: '/mês',
      discount: null,
      featured: false,
      buttonText: 'Escolher',
      buttonVariant: 'btn-secondary',
      isVitalicio: false,
      features: [
        'Acesso a 1 modelo de landing page',
        'Dashboard de métricas',
        'Painel de controle',
        'Hospedagem rápida inclusa',
        'Manutenção simples periódica',
        'SSL Grátis & Criptografia',
        'Otimização de SEO',
        'Cancelamento simples a qualquer momento'
      ]
    },
    {
      id: 'trimestral',
      name: 'Assinatura Trimestral',
      price: 'R$ 229,50',
      period: '/trimestre',
      discount: '10% de desconto',
      featured: true,
      buttonText: 'Escolher',
      buttonVariant: 'btn-primary',
      isVitalicio: false,
      features: [
        'Economia de R$ 25,50 a cada 3 meses',
        'Tudo do plano mensal',
        '1 alteração de layout total por trimestre (opcional)',
        'Maior flexibilidade em ajustes individuais',
        'Otimização de SEO'
      ]
    },
    {
      id: 'anual',
      name: 'Assinatura Anual',
      price: 'R$ 816,00',
      period: '/ano',
      discount: '20% de desconto',
      featured: false,
      buttonText: 'Escolher',
      buttonVariant: 'btn-secondary',
      isVitalicio: false,
      features: [
        'Economia de R$ 204,00 por ano',
        'Tudo do plano mensal',
        'Tudo do plano trimestral',
        'Domínio .com.br grátis por 1 ano',
        '4 alterações de layout total por ano (opcional)',
      ]
    },
    {
      id: 'vitalicio',
      name: 'Assinatura Vitalícia',
      price: 'R$ 2.500,00',
      period: 'a partir de (Pagamento Único)',
      discount: 'Sem mensalidades para sempre',
      featured: false,
      buttonText: 'Solicitar orçamento',
      buttonVariant: 'btn-whatsapp',
      isVitalicio: true,
      features: [
        'Pagamento único e licença perpétua',
        'Código-fonte 100% entregue',
        'Customização total sob medida',
        'Sem cobranças de mensalidade',
        'Instalação no seu próprio servidor',
        'Suporte técnico de implementação por 90 dias'
      ]
    }
  ];

  return (
    <section id="pricing-section" className="section-padding" style={{ backgroundColor: 'var(--bg-main)' }}>
      <div className="container">
        <div className="text-center" style={{ maxWidth: '700px', margin: '0 auto 1.5rem' }}>
          <div className="badge badge-brand" style={{ marginBottom: '0.75rem' }}>
            <Sparkles size={14} />
            Transparência &amp; Flexibilidade
          </div>
          <h2 style={{ fontSize: '2.5rem', color: 'var(--text-title)' }}>
            Planos de Assinatura
          </h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '1.05rem', marginTop: '0.5rem' }}>
            Escolha o modelo de assinatura ideal para o seu negócio ou opte por uma licença vitalícia customizada.
          </p>
        </div>

        <div className="pricing-grid">
          {plans.map((plan) => (
            <div key={plan.id} className={`pricing-card ${plan.featured ? 'featured' : ''}`}>
              {plan.featured && (
                <div className="pricing-badge-top">Mais Popular</div>
              )}

              <div className="pricing-header">
                <h3 className="pricing-name">{plan.name}</h3>
                <div className="pricing-price">{plan.price}</div>
                <div className="pricing-period">{plan.period}</div>
                {plan.discount && (
                  <span className="pricing-discount">{plan.discount}</span>
                )}
              </div>

              <ul className="pricing-features">
                {plan.features.map((feat, idx) => (
                  <li key={idx} className="pricing-feature-item">
                    <Check size={18} />
                    <span>{feat}</span>
                  </li>
                ))}
              </ul>

              <div style={{ marginTop: 'auto' }}>
                <button
                  className={`btn ${plan.buttonVariant}`}
                  style={{ width: '100%' }}
                  onClick={() => {
                    trackWhatsAppClick();
                    if (plan.isVitalicio) {
                      onContact();
                    } else {
                      onChoosePlan(plan);
                    }
                  }}
                >
                  {plan.isVitalicio ? <MessageSquare size={18} /> : null}
                  {plan.buttonText}
                  {!plan.isVitalicio && <ArrowRight size={16} />}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
